import { TypographyPreset } from "@/types/typography";
import { v4 as uuidv4 } from "uuid";
import { globalStore } from "@/store/store-accessor";
import { GLOBAL_SETTINGS_PATHS } from "@/store/modules/global";
import defensiveCopy from "@/util/defensive-copy";

export function getUniqueTypographyPresetId(): string {
  return `preset-id-${uuidv4()}`;
}

export function addTypographyPresetToStore(newPreset: TypographyPreset) {
  const newVal = [
    ...defensiveCopy(
      globalStore.typographyPresets ? globalStore.typographyPresets : []
    ),
    defensiveCopy(newPreset)
  ];

  globalStore.throttledGlobalSettingsPropertyChange({
    path: GLOBAL_SETTINGS_PATHS.typographyPresets,
    value: newVal,
    meta: {
      snapshotLabel: "Add Typography Preset"
    }
  });
}
